import * as types from './index';

export const assUserAddAction = (data) => {
    return {
    type: types.ASS_USER_ADD,
    data
    }
};

export const assUserEditAction = (data) => {
    return {
    type: types.ASS_USER_EDIT,
    data
    }
};

export const assUserUpdateAction = (data) => {
    return {
    type: types.ASS_USER_UPDATE,
    data
    }
};

export const assUserDeleteAction = (data) => {
    return {
    type: types.ASS_USER_DELETE,
    data
    }
};
export const associateUserActivateAction = (data) => {
    return {
    type: types.ASS_USER_ACTIVATE,
    data
    }
};

export const associateUserDeleteAction = (data) => {
    return {
    type: types.ASSOCIATE_USER_DELETE,
    data
    }
};

export const assUserListAction = (data) => {
    return {
    type: types.ASS_USER_LIST,
    data
    }
};

export const assUserDeptListAction = (data) => {
    return {
    type: types.DEPARTMENT_LIST_ASSOC_USER,
    data
    }
};

export const assUserRolesListAction = (data) => {
    return {
    type: types.ROLES_LIST_ASSOC_USER,
    data
    }
};

export const assMuteEmailAction = (data) => {
    return {
    type: types.UPDATE_ASSO_MUTE_EMAIL,
    data
    }
};

export const assMutePushAction = (data) => {
    return {
    type: types.UPDATE_ASSO_MUTE_PUSH,
    data
    }
};

